import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  removeLayout as removeLayoutFromView
} from '../redux/view'
import {
  remove as removeLayout
} from '../redux/layouts'

export default function * requestRemoveLayout (action) {
  const { id } = action.payload

  const optimisticAction = yield optimisticPut([
    removeLayout({
      id
    }),
    removeLayoutFromView({
      id
    })
  ])

  try {
    yield call(apiAction, 'RemoveHomeLayout', {
      id
    })
  } finally {
    yield optimisticAction.revert()
  }
}
